export default __webpack_public_path__ + "static/media/arrowRightWhite.3423580a.svg";